import { render, staticRenderFns } from "./quotation-expired.vue?vue&type=template&id=d310fd2c"
import script from "./quotation-expired.vue?vue&type=script&lang=js"
export * from "./quotation-expired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports